import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CoopValidators } from '@core/helpers/validators.helper';
import { AltreNotLibriSocialiFormValidators } from './validators/altre-not-libri-soc.form-validators';
import { AltreNotLibriSocWarningService } from './warnings/altre-not-libri-soc.warnings';
import { MyVerbale } from '../../models/interfaces/revisione.interface';
import { buildOrganoControlloFormArray } from '../amm-controllo/common/helpers/norme-form-groups.helper';
import { BaseRevisioneFormService } from '../../abstracts/base-revisione-form.service';
import { formPaths } from '@shared/constants/form-paths.const';
import { AltreNotLibriSocFormListeners } from './listeners/altre-not-libri-soc.form-listeners';
import { buildAllegatiFormArray } from './common/builders/altre-not-libri-soc-form-array.builder';

@Injectable()
export class AltreNotLibriSocFormService extends BaseRevisioneFormService<AltreNotLibriSocWarningService> {
    constructor(protected warningService: AltreNotLibriSocWarningService) {
        super(warningService);
    }

    override get dependencyPaths(): Set<string> {
        return new Set([
            // Altri allegati
            'my_AltriAllegati.my_AltroAllegato',

            // Dati identificativi
            `${formPaths.datiIdentificativi}.my_DenominazEnte`,
            `${formPaths.datiIdentificativi}.my_DataUltRev`,

            // Amministrazione controllo
            `${formPaths.ammControllo}.my_CkNorme`,
            `${formPaths.ammControllo}.my_NormeSrl.my_CkSrlAffidamContrCont`,
            `${formPaths.ammControllo}.my_NormeSpaOrdinario.my_CkSpoAffidamContrCont`,
            `${formPaths.ammControllo}.my_NormeSpaDualistico.my_CkSpdAffidamContrCont`,
            `${formPaths.ammControllo}.my_NormeSpaMonistico.my_CkSpmAffidamContrCont`,
            `${formPaths.ammControllo}.my_AllCollegioSindacale.my_AllElemCollegioSindacale`,
        ]);
    }

    override initListener(): void {
        new AltreNotLibriSocFormListeners(this._form, this.store).setListeners();
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_AltriAllegati: this.fb.group({
                    my_AltroAllegato: this.fb.array([]),
                }),

                my_SezioneI__Rilevazione: this.fb.group({
                    my_DatiIdentificativi: this.fb.group({
                        my_DenominazEnte: '',
                        my_DataUltRev: '',
                    }),

                    my_AmministrazioneControllo: this.fb.group({
                        my_CkNorme: '',

                        my_NormeSrl: this.fb.group({
                            my_CkSrlAffidamContrCont: '',
                        }),

                        my_NormeSpaOrdinario: this.fb.group({
                            my_CkSpoAffidamContrCont: '',
                        }),

                        my_NormeSpaDualistico: this.fb.group({
                            my_CkSpdAffidamContrCont: '',
                        }),

                        my_NormeSpaMonistico: this.fb.group({
                            my_CkSpmAffidamContrCont: '',
                        }),

                        my_AllCollegioSindacale: this.fb.group({
                            my_AllElemCollegioSindacale: this.fb.array([]),
                        }),
                    }),

                    my_AltreNotizie: this.fb.group({
                        my_CkVertenzeGiudiz: ['', CoopValidators.required],
                        my_DescVertenzeGiudiz: '',
                        my_VertenzeGiudizImpPres: '',
                        my_data_blocco_semestrale: '',
                        my_CkIntevenutaSospensioneSemestrale: '',
                        my_CkProdottoAttoNotorio: '',
                        my_CkLibriSociali: ['', CoopValidators.required],
                        my_CkLibriSocBolloVid: '',
                        my_CkLibriSocTassa: '',
                        my_CkLibroSociDati: ['', CoopValidators.required],
                        my_NoteLibroSoci: '',
                        my_CkLibroAssVerb: ['', CoopValidators.required],
                        my_CkLibroAssRedaz: ['', CoopValidators.required],
                        my_CkLibroAssVerbSott: ['', CoopValidators.required],
                        my_CkLibroAssTrascritti: ['', CoopValidators.required],
                        my_NoteLibroAssemb: '',
                        my_CkLibroAssSpeciali: ['', CoopValidators.required],
                        my_NoteLibroAssSpeciali: '',
                        my_CkLibroOrgAmm: ['', CoopValidators.required],
                        my_NoteLibroOrgAmm: '',
                        my_CkLibroOrgContr: '',
                        my_CkLibroOrgContrNat: '',
                        my_NoteLibroOrgContr: '',
                        my_CkLibroContrCont: '',
                        my_NoteLibroContrCont: '',
                        my_CkLibroGioInv: ['', CoopValidators.required],
                        my_CkLibroGioInvAgg: '',
                        my_CkLibroGioInvBollo: '',
                        my_CkLibroGioInvLR: '',
                        my_CkAltriLibri: ['', CoopValidators.required],
                        my_NoteOsserLibri: '',
                        my_CkVerbConoscSoci: '',
                        my_DescVerbConoscSoci: '',
                        my_Altro: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: AltreNotLibriSocialiFormValidators,
            }
        );
    }

    protected override afterPopulateForm(myVerbale: MyVerbale): void {
        buildOrganoControlloFormArray(this.fb, myVerbale, this._form);
        buildAllegatiFormArray(this.fb, myVerbale, this._form);
    }
}
